import axios from 'axios';
 
class CredentialService { 
  postConfirmPassword(idProgram, payload) {
    return axios.post(`/program/credentials/${idProgram}/auth`,payload); 
  }

  postCredential(programId, payload) {
    return axios.post(`/program/credentials/${programId}`,payload); 
  }
  postCredentialHacker(programId, idHacker, payload) {
    return axios.post(`/program/credentials/${programId}?hacker=${idHacker}`,payload); 
  }
  getCredential(programId) {
    return axios.get(`/program/credentials/${programId}`); 
  } 
  getCredentialHacker(programId, idHacker) {
    return axios.get(`/program/credentials/${programId}?hacker=${idHacker}`); 
  }
  deleteCredentialHacker(programId, idHacker) {
    return axios.delete(`/program/credentials/${programId}?hacker=${idHacker}`); 
  } 
  deleteCredential(programId) {
    return axios.delete(`/program/credentials/${programId}`); 
  } 
}

export default new CredentialService();